var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Smiley',{staticClass:"bcx-pointer",attrs:{"type":_vm.type,"size":_vm.size,"is-active":_vm.isActive},nativeOn:{"click":function($event){return _vm.select.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }